import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';

import LoaderSVG from '../static/icons/loader.svg';

const Icon = styled(SVG)`
  animation-delay: 0.5s;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: fadeIn;
  height: 10rem;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const Loader = () => (
  <Icon src={LoaderSVG} />
);

export default Loader;
